<div #selector class="custom-selecter">
  <select placeholder="">
    <!--<ng-content></ng-content>-->
    <option *ngFor="let option of options" [value]="option.value">{{ option.title }}</option>
  </select>
</div>
